module.exports = __webpack_public_path__ + "img/GALLERY-FRONX-BOOSTERGREEN-2.72202c22.jpg";